module.exports = __webpack_public_path__ + "media/site_templates/www.lawnmowingservices.me/images/testimonials-96baa75c5bb2c6281a3461198cbde67d.jpg";